import { Card, CardBody, Col } from "reactstrap";
import { fileUploadData } from "../../../../Data/BonusUi/Dropzone/Dropzone";
import CardHeaderCommon from "../../../../Utils/CommonComponents/CardHeaderCommon";
import CommonFileUpload from "../../../../Utils/CommonComponents/CommonFileUpload";
import { MultiFileUploads } from "../../../../Utils/Constants";

const MultiFileUpload = () => {
  return (
    <Col lg="6">
      <Card>
        <CardHeaderCommon title={MultiFileUploads} span={fileUploadData} />
        <CardBody>
          <CommonFileUpload multiple />
        </CardBody>
      </Card>
    </Col>
  );
};

export default MultiFileUpload;
